export default "__VITE_ASSET__b07abc13__"